import { IModel } from '../base/annotation';
import { Metamodel } from '../base/model';

@Metamodel.model({
    name: 'CredentialProperties',
    abstract: true
})
export abstract class CredentialProperties {
    public static readonly MODEL: IModel;
}
